import React, { useContext } from 'react';
import { OverlayTrigger, Popover, PopoverContent, PopoverTitle } from 'react-bootstrap';
import { TopNavContext } from '../../contexts/TopNavContext';
import { CabinetClient, IOrderSolutionRequest, IUserSolution, OrderSolutionRequest, UserRight } from '../../services/WebApiClient';
import { useClient } from '../../util/useClient';
import { useState2 } from '../../util/useState2';
import { EditorContext } from '../EditorCommon/EditorContext';
import { LoadSpinnerOverlay } from '../LoadSpinnerOverlay/LoadSpinnerOverlay';
import "./OrderButton.scss"
import { OrderConfirmationModal } from './OrderConfirmationModal';
import { OrderModal } from './OrderModal';


export function OrderButton(props: {
    solution: IUserSolution;
    orderChanged: () => void;
    onOrderComplete: (us: IUserSolution) => void;
}) {

    const ec = useContext(EditorContext);
    const topBarContext = useContext(TopNavContext);
    const cabinetClient = useClient(CabinetClient);
    const currentState = useState2<
        { s: "initial" }
        | { s: "ordering" }
        | { s: "processing" }
        | { s: "showingConfirmation", orderNumber: string}
    >({ s: "initial" });

    if (props.solution.orderedAt !== null) {
        return (<>
            <button className="btn btn-outline-success disabled order-button"
                disabled
            >
                {ec.translator("user solution order button text alreadyordered", "Bestilt")}
            </button>
            {currentState.value.s === "showingConfirmation" && <OrderConfirmationModal
                orderNumber={currentState.value.orderNumber}
                onClose={() => currentState.set({ s: "initial" })} />}
        </>);
    }


    if (!topBarContext.currentUser?.userRights.find(ur => ur === UserRight.OrderSolution)) {
        const overlay = (
            <Popover id="popover-order-button" >
                <PopoverTitle>
                    {ec.translator("user solution order button popover title notallowed", "Bestil")}
                </PopoverTitle>
                <PopoverContent style={{ whiteSpace: "pre-line" }}>
                    {ec.translator(
                        "user solution order button popover text notallowed",
                        "Kontakt din lokale butik for at bestille løsningen. Oplys dit navn eller telefonnummer, så finder vores ekspedient din løsning.")}
                </PopoverContent>
            </Popover>
        );
        return (
            <OverlayTrigger trigger={["hover", "focus"]} overlay={overlay} placement="bottom" >
                <button className="btn btn-outline-primary disabled order-button"
                    disabled
                >
                    {ec.translator("user solution order button text notallowed", "Bestil")}
                </button>
            </OverlayTrigger>
        );
    }


    async function orderSolution(orderInfo: IOrderSolutionRequest | undefined) {

        currentState.set({ s: "processing" });

        try {
            if (!orderInfo) {
                currentState.set({ s: 'initial' });
                return; //User closed the orderModal without pressing "Order"
            }

            const response = await cabinetClient.orderSolution(props.solution.id, new OrderSolutionRequest(orderInfo));
            currentState.set({ s: "showingConfirmation", orderNumber: response.orderNumber });
            props.onOrderComplete(props.solution);
        }
        catch (e) {
            //Ignore
            currentState.set({ s: 'initial' });
        }
        finally {
            props.orderChanged();
        }
    }




    return (
        <>
            <button className="btn btn-outline-primary order-button"
                onClick={() => currentState.set({ s: "ordering" })}
            >
                {ec.translator("user solution order button text", "Bestil")}
            </button>
            {currentState.value.s === "ordering" && <OrderModal us={props.solution} onClose={orderSolution} />}
            {currentState.value.s === "processing" && <LoadSpinnerOverlay />}
        </>
    );
}
